import {SHOW_LOADING} from "./types";

export function showLoading(loading: boolean) {
  return {
    type: SHOW_LOADING,
    loading
  };
}
